import React, { useState } from 'react';

import { AnimatePresence } from 'framer-motion';

import { CardMedia, CardName } from '@pkg/components';
import { type MarketplaceCardProps } from '@pkg/components/Common/CardTile/types/token';
import { useBreakpoints, useGetPortfolioLid, useLiquidIdAddItem, useLiquidIdRemoveItem } from '@pkg/hooks';

import { AddButton, CardInside, CardMediaHolder, Cover, Wrapper } from './styles';

export const AddToLiquidIdCard = ({
    item,
    cardSize,
    isOwner,
    height,
    collectionData,
    hideCollectionData = false,
}: MarketplaceCardProps) => {
    const { imageUrl, animationUrl, collection } = item || {};

    const lidItemString = item.id;
    const { mutate: addItem, isPending: isLoadingAdd } = useLiquidIdAddItem();
    const { mutate: removeItem, isPending: isLoadingRemove } = useLiquidIdRemoveItem();
    const { data: lidData, isLoading: isLoadingCurr } = useGetPortfolioLid();

    const addedToLid = lidData?.items.some((item) => item === lidItemString);

    const isLoading = isLoadingAdd || isLoadingRemove || isLoadingCurr;
    const hasTooManyItems = lidData?.items.length === 6 && !addedToLid;

    const handleActionItem = () => {
        if (addedToLid) {
            removeItem(lidItemString);
        } else {
            if (hasTooManyItems) return;
            addItem(lidItemString);
        }
    };

    const [isHovering, setIsHovering] = useState(false);
    const { isMobile } = useBreakpoints();

    const addText = isMobile ? 'Add' : 'Add to Liquid ID';

    return (
        <Wrapper onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
            <AnimatePresence>
                {(isHovering || addedToLid || isMobile) && (
                    <Cover
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={handleActionItem}
                        $disabled={hasTooManyItems}
                    >
                        {!hasTooManyItems && (
                            <AddButton
                                $disabled={isLoading}
                                $addedToLid={addedToLid}
                                initial={{ scale: 0.8 }}
                                animate={{ scale: 1 }}
                                exit={{ scale: 0.8 }}
                            >
                                {isLoading ? 'Please wait...' : addedToLid ? 'Remove' : addText}
                            </AddButton>
                        )}
                    </Cover>
                )}
            </AnimatePresence>
            <CardInside $cardSize={cardSize} $height={height}>
                <CardMediaHolder>
                    <CardMedia
                        item={item}
                        image_url={imageUrl}
                        animation_url={animationUrl}
                        cardSize={cardSize}
                        isOwner={isOwner}
                        collectionData={collectionData || collection}
                        hideRarityRank={true}
                        canHover={false}
                    />
                </CardMediaHolder>

                <CardName
                    item={item}
                    cardSize={cardSize}
                    hideCollectionData={hideCollectionData}
                    collectionData={collectionData || collection}
                />
            </CardInside>
        </Wrapper>
    );
};
